import styles from './Collapse.module.css';
import { IconArrowDown, IconArrowUp } from '@axafr-btc-ds/icons';
import { Link } from '@axafr-btc-ds/link';
import { CollapseProps } from './Collapse.interface';
import { ColorHex } from '@axafr-btc-ds/colors';
import classNames from 'classnames';

export const Collapse = ({ title, expanded, children, className, onClick }: CollapseProps): JSX.Element => {
    return (
        <div>
            { expanded && <div>{ children }</div> }
            <Link
                className={ classNames(styles.collapse, className) }
                onClick={ onClick }
            >
                { expanded ? (
                    <IconArrowUp className={ styles.collapseIcon } color={ ColorHex.axablue } />
                ) : (
                    <IconArrowDown className={ styles.collapseIcon } color={ ColorHex.axablue } />
                ) }
                <span className={ styles.collapseText }>{ title }</span>
            </Link>
        </div>
    );
};
